import validAccnr from "../lib/directives/validAccnr.js";
import validOrgnr from "../lib/directives/validOrgnr.js";
import mapboxgl from "mapbox-gl";
import { createApp } from "vue";
import router from "./router.js";
import { ui } from "vutil";
import { vmap } from "vmap";
import App from "./App.vue";

mapboxgl.accessToken = "pk.eyJ1IjoicmljaGFhcyIsImEiOiJjazhjeGFmYmUwbzZ6M2trYXZrd2Uwemc1In0.qkMjwNRxrOJMKjrX3WmKzg";

const app = createApp(App);

app.directive("valid-accnr", validAccnr);
app.directive("valid-orgnr", validOrgnr);
app.use(router);
app.use(ui);
app.use(vmap);

app.mount("#my");
